import React from 'react'
import './toggle.css'

export default class Toggle extends React.Component {
state={
    checked:true
}
    al(){
        let {checked} = this.state;
        let { day, date,way,month,year} = this.props;
       this.setState({checked:!this.state.checked})
       this.props.func(!checked,day,date,month,year,way)
    }
    render(){

        return (
            <div className="center" >
        <input className='_input_' onChange={()=>this.al()} checked={this.props.val} type="checkbox" className=".cc"  name=""/>
  </div>
    )
}
}
